<template>
  <div
    class="w-full flex justify-between flex-row sm:flex sm:flex-row sm:items-center justify-starts bg-blue items-start sm:px-6 md:px-0 padding-header" >
    <div class="justify-between" :class="typeContainer">
      <a href="https://www.gov.co/home/" target="_blank" rel="noopener"
        aria-label="Ir al sitio web del Gobierno de Colombia">
        <LogoGOV class="h-full w-auto" />
      </a>
      <NavbarUserItem v-if="!havePermissions" class="nav" />
    </div>
  </div>
</template>

<script>
import LogoGOV from "@/components/Brand/LogoGOV";
import NavbarUserItem from "./Navbar/NavbarUserItem.vue";

export default {
  props: {
    typeContainer: {
      type: String,
      default: 'container container-workspace',
      required: true,
    }
  },
  components: {
    LogoGOV,
    NavbarUserItem,
  },
  computed: {
    havePermissions: function () {
      return this.$store.state.session.modules?.length > 0;
    },
  },
};
</script>

<style>
.padding-header {
  padding-bottom: 10px;
  padding-top: 10px;  
}

.nav {
  animation-name: nav-show;
  animation-delay: 0.5s;
  opacity: 0;
  animation-fill-mode: forwards;
}

@keyframes nav-show {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}
</style>
